//@flow

import { call, put, select, takeEvery } from 'redux-saga/effects';
import type { IOEffect } from 'redux-saga/effects';

import { tripica } from '../../api';
import { customerOuidSelector } from '../Customer/selectors';
import { setWalletForfeitureData } from './actions';
import HandleErrorService from '../../lib/handleError';
import { fetchCustomerSaga } from '../Customer/sagas';
import WizzeeLog from '../../lib/wizzeeLog';

export function* fetchWalletForfeitureDataSaga(): Generator<*, *, *> {
  yield call(fetchCustomerSaga);
  try {
    const customerOuid = yield select(customerOuidSelector);
    const walletForfeitureData = yield call([tripica, 'checkWalletForfeiture'], customerOuid);

    yield put(setWalletForfeitureData(walletForfeitureData));
  } catch (error) {
    WizzeeLog.warn('[saga] getWalletForfeitureData', error);
    yield call(HandleErrorService.showToastError, error);
  }
}

export default function* walletSaga(): Generator<IOEffect, void, any> {
  yield takeEvery('FETCH_WALLET_FORFEITURE_DATA', fetchWalletForfeitureDataSaga);
}
